<script>
    import { Button } from "sveltestrap";
    import { createEventDispatcher, onMount, tick } from "svelte";
    import patterns from "./data-pattern";
    import store from "../store";
    import { _log } from "../utils/logger";
    import { getAllPatterns, putPattern, deletePattern } from "../db";
    import { toBase64 } from "../utils/util";
    import l from "../utils/locale";
    import AppIconDraw from "../AppIconDraw.svelte";

    let dispatcher = createEventDispatcher();
    export let id = "stroke";
    let customPatterns = [];
    let isFirstCall = true;
    let fillPattern = { src: "", name: "" };
    let fillPatternFrame = { src: "", name: "" };
    let strokePattern = { src: "", name: "" };
    let currentPattern = { src: "", name: "" };
    let isOpen = false;
    let boxBtnEl;
    let boxEl;
    let isActive = false;

    const onClickHandler = (e) => {
        const classList = Array.from(e.target.parentNode.classList);
        _log("onClickHandler", classList);
        if (
            !classList.some(
                (v) =>
                    v.startsWith("boxP") ||
                    v.startsWith("delete-icon") ||
                    v.startsWith("ionicon") ||
                    v.startsWith("save-btn") ||
                    v.startsWith("add-btn")
            )
        ) {
            isOpen = false;
        }
    };
    $: if (isOpen) {
        _log("addEventListener");
        setTimeout(() => {
            window.addEventListener("click", onClickHandler);
        }, 0);
    }
    $: if (!isOpen) {
        _log("removeEventListener");
        window.removeEventListener("click", onClickHandler);
    }
    onMount(async () => {
        customPatterns = await getAllPatterns();
        return store.subscribe((s) => {
            fillPattern = s.fillPattern;
            fillPatternFrame = s.fillPatternFrame;
            strokePattern = s.strokePattern;
            currentPattern =
                id === "stroke"
                    ? strokePattern
                    : id === "fill"
                    ? fillPattern
                    : id === "frame"
                    ? fillPatternFrame
                    : "";
            _log("currentPattern", currentPattern);

            isActive =
                (id === "fill" && s.currentFill === "pattern") ||
                (id === "stroke" && s.currentStroke === "pattern") ||
                (id === "drawColor" && s.currentFill === "pattern") ||
                (id === "drawStrokeColor" && s.currentStroke === "pattern");
            _log("isActive", id, s.currentFill, s.currentStroke, isActive);
        });
    });

    function imgClickHandler(e, url, isChecked) {
        _log("imgClickHandler", url);
        const pattern = { src: url };
        const img = new Image();
        img.onload = () => {
            pattern.img = img;
            if (isChecked) {
                _log("imgClickHandler isChecked");
                pattern = { img: null, src: "" };
            }
            if (id === "stroke") {
                store.setValues({
                    currentStroke: "pattern",
                    strokePattern: pattern,
                    drawStrokeColor: "rgba(0, 0, 0, 0)",
                    strokeGradient: null,
                });
                window.fabricHelper.updateActive("color_stroke");
            } else if (id === "fill") {
                store.setValues({
                    currentFill: "pattern",
                    fillPattern: pattern,
                    drawColor: "rgba(0, 0, 0, 0)",
                    fillGradient: null,
                });
                window.fabricHelper.updateActive("color_fill");
            } else if (id === "frame") {
                store.setValues({
                    fillPatternFrame: pattern,
                    drawColorFrame: "rgba(0, 0, 0, 0)",
                    fillGradientFrame: null,
                });
            }
            
        };
        if (isFirstCall) {
            isFirstCall = false;
        } else {
            dispatcher("onPatternClick", { url });
        }
        img.width = "50px";
        img.width = "50px";

        img.src = url;
        currentImgUrl = url;
        // boxBtnEl.style.background = `url(${url})`;
        //const isChecked = e.target.getAttribute("checked") === "true";
    }

    function checkFileType(file) {
        let result = false;
        const n = file.name.toLowerCase();
        if (
            file.name.endsWith("jpeg") ||
            file.name.endsWith("jpg") ||
            file.name.endsWith("png") ||
            file.name.endsWith("webp") ||
            file.name.endsWith("gif") ||
            file.name.endsWith("jfif") ||
            file.name.endsWith("svg")
        ) {
            result = true;
        }
        return result;
    }

    async function deletePatternHandler(id) {
        const result = await deletePattern(id);
        _log("deletePatternHandler", result);
        if (result) {
            customPatterns = customPatterns.filter((v) => v.id !== id);
        }
    }

    function onClickAddPattern() {
        const fileInput = document.createElement("input");
        fileInput.setAttribute("type", "file");
        fileInput.setAttribute("accept", "image/*");
        fileInput.setAttribute("multiple", "true");

        fileInput.onchange = async () => {
            const fileList = fileInput.files;
            for (let i = 0; i < fileList.length; i++) {
                const file = fileList[i];
                _log("file", file);
                if (checkFileType(file)) {
                    _log("__file", file);
                    const base64 = await toBase64(file);
                    putPattern({ id: file.name + Date.now(), pattern: base64 });
                    customPatterns = [{ pattern: base64 }, ...customPatterns];
                }
            }
        };
        fileInput.click();
    }

    async function toggleBox() {
        isOpen = !isOpen;
        if (isOpen) {
            await tick();
            const rect = boxBtnEl.getBoundingClientRect();
            if(window.innerHeight <= 400){
                boxEl.style.top = "0px";
            } else {
                boxEl.style.top = `${rect.top - rect.height - 10}px`;
            }
            boxEl.style.left = "170px";
        } else {
            //boxBtnEl.style.background = currentPattern.src;
        }
    }

    let currentImgUrl = "/data/icons/none.png";
    function closeBox() {
        isOpen = false;
        // currentImgUrl = currentPattern.src;
        // boxBtnEl.src = currentPattern.src;
    }
</script>

<img
    class="noselect"
    class:activeColor={isActive}
    alt=""
    src={currentImgUrl}
    id="boxBtn"
    bind:this={boxBtnEl}
    on:click={toggleBox}
/>
{#if isOpen}
    <div tabindex="0" class="boxP" bind:this={boxEl}>
        <div class="flex p-1">
            {#each patterns as url}
                <div class="pattern-wrap" on:click>
                    <figure
                        on:click={closeBox}
                        class:active={url === currentPattern.src}
                    >
                        <img
                            class="imgPreview"
                            src={url}
                            alt=""
                            on:click={(e) =>
                                imgClickHandler(
                                    e,
                                    url,
                                    url === currentPattern.src
                                )}
                        />
                    </figure>
                    {#if url === currentPattern.src}
                        <div class="checked-pattern" on:click>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="ionicon"
                                viewBox="0 0 512 512"
                                ><path
                                    fill="none"
                                    stroke="white"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="32"
                                    d="M416 128L192 384l-96-96"
                                /></svg
                            >
                        </div>
                    {/if}
                </div>
            {/each}
        </div>
        <div class="p-1 center save-btn">
            <Button
                color="primary"
                class="btnFlex"
                on:click={onClickAddPattern}
            >
                <AppIconDraw name="add_to_db" />
                {l["add_pattern"]}
            </Button>
        </div>
        <div class="flex p-1">
            {#each customPatterns as pattern}
                <div class="pattern-wrap" on:click>
                    <figure
                        class:active={pattern.pattern === currentPattern.src}
                    >
                        <img
                            class="imgPreview"
                            src={pattern.pattern}
                            alt=""
                            on:click={(e) =>
                                imgClickHandler(
                                    e,
                                    pattern.pattern,
                                    pattern.pattern === currentPattern.src
                                )}
                        />

                        <div
                            class="delete-icon"
                            on:click={() => deletePatternHandler(pattern.id)}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="ionicon"
                                viewBox="0 0 512 512"
                                ><title>{l["remove"]}</title><path
                                    d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
                                /></svg
                            >
                        </div>
                    </figure>
                    {#if pattern.pattern === currentPattern.src}
                        <div class="checked-pattern" on:click>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="ionicon"
                                viewBox="0 0 512 512"
                                ><path
                                    fill="none"
                                    stroke="white"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="32"
                                    d="M416 128L192 384l-96-96"
                                /></svg
                            >
                        </div>
                    {/if}
                </div>
            {/each}
        </div>
    </div>
{/if}

<style>
    .active {
        box-shadow: 0 0 4px red, 0 1px 12px var(--main-color);
    }
    #boxBtn {
        box-shadow: 0 0 2px red;
        border-radius: 2px;
        margin-left: 10px;
        margin-top: 1px;
        height: 32px;
        width: 32px;
        padding: 0;
        cursor: pointer;
    }

    :global(#deletePattern) {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
    }
    /* figcaption {
        font-size: 12px;
        pointer-events: none;
        left: 0;
        right: 0;
        bottom: 0;
        text-align: center;
        position: absolute;
        color: white;
        background: var(--main-color-opacity);
    } */
    figure {
        margin: 5px;
        position: relative;
    }

    .imgPreview {
        width: 80px;
        height: 50px;
        cursor: pointer;
    }

    .boxP {
        max-width: 560px;
        position: fixed;
        top: 120;
        left: 60;
        z-index: 989889844343;
        box-shadow: 0 1px 12px var(--main-color);
        background: var(--trnasparent-white-color);
    }
</style>
